import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Finance } from "../../models/finance.model";
import Shop from "../../models/shop.model";

import { FinanceService } from "../../services/finance.service";

@Component({
  selector: "ngx-dialog-print-finance",
  templateUrl: "dialog-print-finance.component.html",
  styleUrls: ["dialog-print-finance.component.scss"],
})
export class DialogPrintFinanceComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() finance?: Finance;
  @Input() shop?: Shop;
  @Input() rePrint?: boolean = false;
  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";
  menu = "pos"; //a4 , pos
  isRefLanguage = false;

  constructor(
    protected ref: NbDialogRef<DialogPrintFinanceComponent>,
    private userService: UserService,
    private purchaseService: FinanceService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.print();
    }, 1000);
  }

  selectMenu(value) {
    this.menu = value;
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
